<div [style.display]="isVisible() ? 'block' : 'none'" class="item-container option-item-container">
  @if (properties.selectionType === 'MultiSelect') {
    <div
      class="multi-select-wrapper"
      [ngClass]="{
        vertical: properties.orientation === 'Vertical' && properties.position === 'Bottom',
        horizontal: !(properties.orientation === 'Vertical' && properties.position === 'Bottom')
      }">
      @if (properties.position === 'Bottom') {
        <div [ngClass]="['option-label', 'preserve-newlines']">{{ properties.text.trim() }}</div>
      }

      <div
        class="option-wrapper option-multi-select"
        [ngClass]="{
          horizontal: properties.orientation === 'Horizontal',
          vertical: properties.orientation === 'Vertical'
        }">
        @for (value of values(); track value) {
          <span class="checkbox-wrapper">
            <!--
            Note checkboxes don't use [formControl] because MultiSelect
            stores multiple values in a pipe-delimited string format,
            which doesn't work with checkbox formControl boolean binding
            -->
            <input
              type="checkbox"
              [id]="getInputId(value)"
              [name]="formControlName()"
              [checked]="isChecked(value)"
              (change)="onCheckboxChanged($event, value)" />
            <label
              [for]="getInputId(value)"
              class="value"
              [ngClass]="{ 'label-disabled': isReadonly() || formControl?.disabled }">
              {{ getInputLabel(value) }}
            </label>
          </span>
        }
      </div>

      @if (properties.position === 'Left') {
        <div [ngClass]="['option-label', 'preserve-newlines']">{{ properties.text.trim() }}</div>
      }
    </div>
  }

  @if (properties.selectionType === 'SingleSelect') {
    <div
      class="single-select-wrapper"
      [ngClass]="{
        vertical: properties.orientation === 'Vertical' && properties.position === 'Bottom',
        horizontal: !(properties.orientation === 'Vertical' && properties.position === 'Bottom')
      }">
      @if (properties.position === 'Bottom') {
        <div [ngClass]="['second-column', 'option-label', 'preserve-newlines']">{{ properties.text.trim() }}</div>
      }

      <div
        class="option-wrapper option-single-select"
        [ngClass]="{
          horizontal: properties.orientation === 'Horizontal',
          vertical: properties.orientation === 'Vertical'
        }">
        @for (value of values(); track value) {
          <span class="radio-wrapper">
            <label
              class="value"
              [ngClass]="{ 'label-disabled': isReadonly() || formControl?.disabled }"
              [for]="getInputId(value)">
              <input
                type="radio"
                [formControl]="formControl!"
                [id]="getInputId(value)"
                [name]="formControlName()"
                [value]="getInputValue(value)"
                (change)="onRadioChanged($event, value)" />
              {{ getInputLabel(value) }}
            </label>
          </span>
        }
      </div>

      @if (properties.position === 'Left') {
        <div [ngClass]="['second-column', 'option-label', 'preserve-newlines']">{{ properties.text.trim() }}</div>
      }
    </div>
  }
</div>
